<template>
  <div :id="`map-${uid}`" class="map-container" ref="map">
    <vue-announcer />
    <slot v-if="ready" />
  </div>
</template>

<script>
import L from 'leaflet'
import 'leaflet-providers'
import 'leaflet-extra-markers'
import { getDistance, delay, getWidthInMeters } from '@/utils/utils'

export default {
  name: 'Map',
  props: {
    zoom: {
      type: Number,
      default: 16
    },
    center: {
      type: [Array, Object],
      default: () => [0, 0]
    }
  },
  data () {
    return {
      map: null,
      ready: false,
      uid: Math.floor(Math.random() * 1000000000)
    }
  },
  watch: {
    center (newCenter, oldCenter) {
      this.updateFocus(newCenter, oldCenter)
    },
    zoom (newZoom, oldZoom) {
      const pixelWidth = this.$refs.map.offsetWidth

      const oldWidth = getWidthInMeters(this.center[0], oldZoom, pixelWidth)
      const newWidth = getWidthInMeters(this.center[0], newZoom, pixelWidth)

      const change = oldWidth - newWidth
      const changeWord = (change > 0) ? 'in' : 'out'

      this.$announcer.set(`Zoomed ${changeWord} by ${Math.abs(change).toFixed(2)} meters.`)
    }
  },
  mounted () {
    // Create map tile layers
    // const streets = L.tileLayer.provider('MapBox', {
    //   id: 'mapbox/streets-v11',
    //   accessToken: process.env.VUE_APP_MAPBOX_ACCESS_TOKEN,
    //   tileSize: 512,
    //   zoomOffset: -1
    // })

    const streets = L.tileLayer.provider('Jawg', {
      variant: process.env.VUE_APP_JAWG_STYLE,
      accessToken: process.env.VUE_APP_JAWG_ACCESS_TOKEN
    })

    const satellite = L.tileLayer.provider('MapBox', {
      id: 'mapbox/satellite-streets-v11',
      accessToken: process.env.VUE_APP_MAPBOX_ACCESS_TOKEN,
      tileSize: 512,
      zoomOffset: -1
    })

    // const stadia = L.tileLayer('https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}{r}.png', {
    //   maxZoom: 20,
    //   attribution: '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
    // })

    // Initialize map
    this.map = L.map(`map-${this.uid}`, {
      center: this.center,
      zoom: this.zoom,
      closePopupOnClick: false,
      watch: true,
      layers: [streets]
    })

    const baseLayers = {
      Satellite: satellite,
      Streets: streets
      // Stadia: stadia
    }

    L.control.layers(baseLayers, {}, {
      position: 'bottomright'
    }).addTo(this.map)

    this.map.on('locationfound', (e) => { this.$emit('location-found', e) })
    this.map.on('zoomend', (e) => { this.onZoomEnd(e) })
    this.map.on('click', (e) => this.$emit('click', e))

    this.ready = true
    this.$emit('ready', this.map)
  },
  methods: {
    onZoomEnd (event) {
      this.$emit('update:zoom', event.target.getZoom())
    },
    async updateFocus (newCenter, oldCenter) {
      const distance = getDistance(newCenter, oldCenter)
      const animate = distance < 1000

      this.map.flyTo(this.center, this.zoom, { animate })

      if (animate) {
        await delay(250)
      }

      this.$emit('update:focus-updated', {
        coordinates: this.center,
        zoom: this.zoom
      })
    }
  }
}
</script>

<style lang="scss">
@import '../../../node_modules/leaflet/dist/leaflet.css';

.map-container {
  width: 100%;
  height: 100%;
  z-index: 0;

  .leaflet-routing-container {
    opacity: 0;
    height: 0;
    width: 0;
  }
}
</style>
